import "./DataCentres.module.css";
import Header from "@/reusable_sections/Header";
import Datacentre from "./sections/Datacentre";
import SiteCompliance from "./sections/SiteCompliance";
import Accountability from "./sections/Accountability";
import Footer from "@/reusable_sections/Footer";
export default function DataCentresPage() {
  return <div>
      <Header />
      <Datacentre />
      <SiteCompliance />
      <Accountability />
      <Footer />
    </div>;
}